<template>
  <div class="w-100">
    <div class="d-flex w-100" ref="fadeWhenModelOpen">
      <div class="value-style d-inline-flex bg-transparent rounded text-light input-fields searched-metadata-display-fields">
        <ul class="tags-display-ul p-0 w-100 m-0" style=" display: grid;">
          <div style="display: grid;">
            <li style="display:inline-flex">
              <table
                class="table-scroll"
                style="background: transparent; width: 91%"
                >
                <thead>
                  <tr>
                    <th scope="col" style="width: 30%" class="text-left col-md-3">
                    </th>
                    <th scope="col" style="width: 60%" class="text-center col-md-6">
                    </th>
                    <th scope="col" style="width: 10%" class="text-center col-md-1"></th>
                  </tr>
                </thead>
                <tbody class="body-half-screen">
                  <template v-for="key in loadValueType">
                    <tr v-if="(isFieldType(key.type) && isFieldExists(key.id_list[0])) || !isFieldType(key.type)" :key="key.type" class="comm-table-row">
                    <td class="text-left" style="width:30%">
                        <Multiselect
                            v-model="labelOfLoadTypes[key.uuid]"
                            :options="loadTypes"
                            :searchable="true"
                            :close-on-select="true"
                            :allow-empty="false"
                            @select="updateRowType($event,key)"
                            label="label"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            track-by="type">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                            </div>
                        </Multiselect>
                    </td>
                    <td class="text-center" style="width:62%">
                      <div v-if="key.type == 'Catalog'" style="display: flex;position:relative" class="comm-screen-profile-fields">
                        <div class="select-catalog-field" :class="{focusField:activeField == 'category'}"
                          v-on:click="activeField = 'category'">
                          <div class="value-style" style="padding-inline-end:0px">
                            <div class="w-100" style="display: flex;width:100%;position:relative">
                                <span class="key-style"> is </span>
                                <template v-if="!isEditing(key.uuid) && !newProfile && isNewRow != key.uuid">
                                <div  class="fields-on-non-edit-mode">
                                  <span v-if="key == undefined ||
                                              key.catalog_info == undefined ||
                                              key.catalog_info.length == 0"  class="empty-field-text-styles">NONE</span>
                                  <template v-else>
                                    <div style="display:inline-grid;">
                                      <span v-for="catEntry of key.catalog_info" :key="catEntry._id" style="word-break: break-all;line-height: normal;margin-top:3px">
                                        {{catEntry.catalog_name + " [" +
                                            (Array.isArray(catEntry.parent_path)?catEntry.parent_path[0].value.replace("catalog://0",""):catEntry.parent_path.value.replace("catalog://0","")) + " ]"}}
                                      </span>
                                    </div>
                                  </template>
                                </div>
                                <edit-icon v-on:click.native="editingKey = key.uuid" class="editIconClass"></edit-icon>
                              </template>
                                <div v-else-if="isEditing(key.uuid) || newProfile || isNewRow == key.uuid" class="input-field-wrapper" style="width:73% !important">
                                  <multi-catalog-dropdown :enableCatBrowser='true' :componentUUID="key.uuid" :selectedOptions="key.catalog_info" ref="catalogComponentRef" style="margin-inline-end: 3px;margin-inline-start:5px;width:100%"></multi-catalog-dropdown>
                                  <div v-if="(isEditing(key.uuid) || isNewRow == key.uuid) && !newProfile">
                                    <save-icon v-on:click.native="refreshSelectedCatalog(key.uuid)"></save-icon>
                                    <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="key.type == 'MimeType'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative;">
                        <span class="key-style"> is </span>
                        <div v-if="!isEditing(key.value) && !newProfile && isNewRow != key.uuid" class="fields-on-non-edit-mode">
                            <span v-if="key.value != undefined && key.value.length == 0"  class="empty-field-text-styles">NONE</span>
                            <span v-else>{{key.value}}</span>
                            <edit-icon v-on:click.native="editingKey = key.value" class="editIconClass"></edit-icon>
                        </div>
                        <div v-else-if="isEditing(key.value) || newProfile || isNewRow == key.uuid" class="input-field-wrapper">
                          <Multiselect
                              :value="mimeTypeValue.label"
                              :options="mimeTypeList"
                              :searchable="false"
                              :close-on-select="true"
                              :allow-empty="false"
                              @select="updateMimeType($event, key.uuid)"
                              :label="label"
                              deselectLabel=""
                              selectLabel=""
                              selectedLabel=""
                              :track-by="type">
                              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                              </div>
                          </Multiselect>
                          <div v-if="(isEditing(key.value) || isNewRow == key.uuid) && !newProfile">
                            <save-icon v-on:click.native="saveEditedField(key.value,key.uuid)"></save-icon>
                            <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="key.type == 'User'" class="comm-screen-profile-fields"  style="display: flex;position:relative;width:100%;">
                        <span class="key-style"> is </span>
                        <div v-if="!isEditing('user') && !newProfile && (isNewRow != key.uuid || isNewRow == null)" class="fields-on-non-edit-mode" style="margin-top:11px;">
                            <span v-if="selectedUsersIdNameMap[key.uuid] != undefined && selectedUsersIdNameMap[key.uuid].length == 0"  class="empty-field-text-styles" style="position: relative;bottom: 10px;">NONE</span>
                            <div v-else v-for="user in selectedUsersIdNameMap[key.uuid]" :key="user._id" class="tags-style">
                              <div class="user-name-or-image-in-selected-option" :style="style(user.username)">{{ user.username.split("")[0] }}</div>
                              <div class="user-name-display user-name-display-as-tags">{{user.username}}</div>
                            </div>
                            <edit-icon v-on:click.native="editingKey = 'user'" class="editIconClass"></edit-icon>
                        </div>
                        <div v-else-if="isEditing('user') || newProfile || isNewRow == key.uuid" class="input-field-wrapper">
                          <users-multiselect :selectedUserIdList="key.id_list" :componentUuid="key.uuid" :enableCheckbox="true" :isSearchable="true" :selectedUserIdNameMap="getSelectedUserIdList(key.uuid)" ref="userComponentRef"></users-multiselect>
                          <div v-if="(isEditing('user') || isNewRow == key.uuid) && !newProfile">
                            <save-icon v-on:click.native="saveFieldComponentsValue(key.uuid)"></save-icon>
                            <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="key.type == 'UserGroup'" class="comm-screen-profile-fields"  style="display: flex;position:relative;width:100%;">
                        <span class="key-style"> is </span>
                        <div v-if="!isEditing('userGroup') && !newProfile && isNewRow != key.uuid" class="fields-on-non-edit-mode" style="margin-top:11px;">
                            <span v-if="addedUserGroupList != undefined && addedUserGroupList.length == 0"  class="empty-field-text-styles" style="position: relative;bottom: 10px;">NONE</span>
                            <div v-else v-for="group in addedUserGroupList" :key="group.user_group_id" class="tags-style">
                            <div class="user-name-or-image-in-selected-option"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                                  <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                                  <path fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"/>
                                  <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                                  </svg>
                              </div>
                              <div class="user-name-display user-name-display-as-tags">{{group.name}}</div>
                            </div>
                            <edit-icon v-on:click.native="editingKey = 'userGroup'" class="editIconClass" style="line-height: 25px;"></edit-icon>
                        </div>
                        <div v-else-if="isEditing('userGroup') || newProfile || isNewRow == key.uuid" class="input-field-wrapper">
                        <userGroup-dropdown :componentUuid="key.uuid" :enableCheckbox="true" :selectedUserGroupList="addedUserGroupList" :selectedUserGroupIds="key.id_list" ref="userGroupComponentRef"></userGroup-dropdown>
                        <div v-if="(isEditing('userGroup')  || isNewRow == key.uuid) && !newProfile">
                          <save-icon v-on:click.native="saveFieldComponentsValue(key.uuid)"></save-icon>
                          <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                        </div>
                        </div>
                      </div>
                      <div v-else-if="key.type == 'Screen'" class="comm-screen-profile-fields" style="display: flex;position:relative;width:100%;">
                        <span class="key-style"> is </span>
                        <div v-if="!isEditing('screens') && !newProfile && isNewRow != key.uuid" class="fields-on-non-edit-mode" style="margin-top:11px;">
                          <span v-if="screenTypes.length == 0"  class="empty-field-text-styles" style="position: relative;bottom: 10px;">NONE</span>
                          <div v-else v-for="screen in screenTypes" :key="screen._id" class="tags-style">
                              <div class="user-name-display user-name-display-as-tags">{{screen.name}}</div>
                            </div>
                          <edit-icon v-on:click.native="editingKey = 'screens'" class="editIconClass"></edit-icon>
                        </div>
                        <div v-else-if="isEditing('screens') || newProfile || isNewRow == key.uuid" class="input-field-wrapper">
                          <Multiselect
                            v-model="screenTypes" 
                            :options="screenTypesOptions"
                            :multiple="true"
                            track-by="_id"
                            label="name"
                            :custom-label="screenTypeLabelCallback"
                            :close-on-select="false"
                            :show-no-results="false"
                            deselectLabel =""
                            selectLabel=""
                            selectedLabel=""
                            :placeholder="$t('Enter screen name')"
                            :hideSelected="false"
                            :showNoOptions="false"
                            @search-change="getscreensOnKeyup($event)"
                            @select="screenTypeOnSelect($event, key.uuid)"
                            @remove="screenTypeOnRemove($event, key.uuid)">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeScreensCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.name"/>
                            <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
                            </div>
                            <span slot="noResult">No results</span>
                            <span slot="noOptions" style="display:none"></span>
                          </Multiselect>
                          <div v-if="(isEditing('screens') || isNewRow == key.uuid) && !newProfile">
                            <save-icon v-on:click.native="saveFieldComponentsValue(key.uuid)"></save-icon>
                            <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="key.type == 'AdvancedExpression'" class="comm-screen-profile-fields" style="display:flex;width:94%;width:100%;">
                        <span class="key-style"> matches </span>
                        <div v-if="!isEditing('advancedExp') && !newProfile && isNewRow != key.uuid" class="fields-on-non-edit-mode">
                          <span v-if="advancedExp.length == 0"  class="empty-field-text-styles">NONE</span>
                          <span>{{advancedExp}}</span>
                          <edit-icon v-on:click.native="editingKey = 'advancedExp'" class="editIconClass"></edit-icon>
                        </div>
                        <div v-else-if="isEditing('advancedExp') || newProfile || isNewRow == key.uuid" class="input-field-wrapper">
                          <input
                          type="text"
                          id="name_value"
                          class="rounded text-light comm-input-field-style"
                          style="max-height: 300px;margin-bottom: 4px;margin-top:4px;height: 42px;margin-inline-start:1px;"
                          v-model="advancedExp"
                          autocomplete="off"
                        />
                        <div v-if="(isEditing('advancedExp') || isNewRow == key.uuid) && !newProfile">
                          <save-icon v-on:click.native="saveFieldComponentsValue(key.uuid)"></save-icon>
                          <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                        </div>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="key.type =='FREETEXT'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                          <span class="key-style"> contains</span>
                          <div v-if="!isEditing(key.uuid) && !newProfile && isNewRow != key.uuid" class="fields-on-non-edit-mode">
                            <span v-if="key.value != undefined && key.value.length == 0"  class="empty-field-text-styles">NONE</span>
                            <span v-else>{{key.value}}</span>
                            <edit-icon v-on:click.native="editingKey = key.uuid" class="editIconClass"></edit-icon>
                          </div>
                          <div v-else-if="isEditing(key.uuid) || newProfile || isNewRow == key.uuid" class="input-field-wrapper">
                            <input
                                      type="text"
                                      id="field_value"
                                      class="rounded text-light comm-input-field-style"
                                      v-model="key.value"
                                      autocomplete="off"
                                      placeholder="ex: Olympics"
                                      style="height: 42px;position: relative;bottom: 2px;top:5px"
                            />
                            <div v-if="(isEditing(key.uuid) || isNewRow == key.uuid) && !newProfile">
                              <save-icon v-on:click.native="saveEditedField(key.value,key.uuid)"></save-icon>
                              <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                            </div>
                          </div>
                        </div>
                        <div v-if="key.type == 'FREETEXT_MULTILINE'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                          <span class="key-style"> contains</span>
                          <div v-if="!isEditing(key.uuid) && !newProfile && isNewRow != key.uuid" class="fields-on-non-edit-mode">
                            <span v-if="key.value.length == 0"  class="empty-field-text-styles">NONE</span>
                            <span v-else style="text-align:start;line-height:normal">{{key.value}}</span>
                            <edit-icon v-on:click.native="editingKey = key.uuid" class="editIconClass"></edit-icon>
                          </div>
                          <div v-else-if="isEditing(key.uuid) || newProfile || isNewRow == key.uuid" class="input-field-wrapper">
                            <textarea
                                      id="field_value"
                                      class="rounded text-light comm-input-field-style"
                                      v-model="key.value"
                                      autocomplete="off"
                                      placeholder="ex: Olympics"
                                      style="height: 100px;position: relative;bottom: 2px;top:5px;margin-bottom:5px;"
                            ></textarea>
                            <div v-if="(isEditing(key.uuid) || isNewRow == key.uuid) && !newProfile">
                              <save-icon v-on:click.native="saveEditedField(key.value,key.uuid)"></save-icon>
                              <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                            </div>
                          </div>
                        </div>
                        <div v-if="key.type == 'DATE'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                          <span class="key-style"> between</span>
                          <div v-if="!isEditing(key.uuid) && !newProfile && isNewRow != key.uuid" class="fields-on-non-edit-mode">
                            <span v-if="Object.keys(key.value).length == 0"  class="empty-field-text-styles">NONE</span>
                            <span v-else style="text-align:start">{{key.value[0] + ' ~ ' + key.value[1]}}</span>
                            <edit-icon v-on:click.native="editingKey = key.uuid" class="editIconClass"></edit-icon>
                          </div>
                          <div v-else-if="isEditing(key.uuid) || newProfile || isNewRow == key.uuid" class="input-field-wrapper">
                            <date-picker
                                      range
                                      v-model="selectedTime"
                                      valueType="format"
                                      placeholder="ex: yyyy-mm-dd ~ yyyy-mm-dd"
                                      class="text-light comm-input-field-style"
                                      style="padding: 0px;border-radius: 5px;position:relative;top:6px"
                                      :id="key.uuid"
                                      @change="key.value = selectedTime"
                            ></date-picker>
                            <div v-if="(isEditing(key.uuid) || isNewRow == key.uuid) && !newProfile">
                              <save-icon v-on:click.native="saveEditedField(selectedTime,key.uuid)"></save-icon>
                              <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                            </div>
                          </div>
                        </div>
                        <div v-if="key.type == 'DATE_TIME'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                          <span class="key-style"> between</span>
                          <div v-if="!isEditing(key.uuid) && !newProfile && isNewRow != key.uuid" class="fields-on-non-edit-mode">
                            <span v-if="Object.keys(key.value).length == 0"  class="empty-field-text-styles">NONE</span>
                            <span v-else style="text-align:start">{{key.value[0] + ' ~ ' + key.value[1]}}</span>
                            <edit-icon v-on:click.native="editingKey = key.uuid" class="editIconClass"></edit-icon>
                          </div>
                          <div v-else-if="isEditing(key.uuid) || newProfile || isNewRow == key.uuid" class="input-field-wrapper">
                            <date-picker
                                      range
                                      v-model="selectedDateTime"
                                      placeholder="ex: yyyy-mm-dd hh:mm:ss ~ yyyy-mm-dd hh:mm:ss"
                                      class="text-light comm-input-field-style"
                                      style="padding: 0px;border-radius: 5px;position:relative;top:6px;width: 100%;"
                                      :id="key.uuid"
                                      type="datetime"
                                      valueType="format"
                                      @change="key.value = selectedDateTime"
                                      confirm
                            ></date-picker>
                            <div v-if="(isEditing(key.uuid) || isNewRow == key.uuid) && !newProfile">
                              <save-icon v-on:click.native="saveEditedField(selectedDateTime,key.uuid)"></save-icon>
                              <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                            </div>
                          </div>
                        </div>
                        <div v-if="key.type == 'INTEGER'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                          <span class="key-style" style="width:31%"> from</span>
                          <div v-if="!isEditing(key.uuid) && !newProfile && isNewRow != key.uuid" class="fields-on-non-edit-mode">
                            <span v-if="key.value == undefined || (key.value != undefined && key.value.length == 0)"  class="empty-field-text-styles">NONE</span>
                            <span v-else>{{key.value['from'] + "  to  " + key.value['to']}}</span>
                            <edit-icon v-on:click.native="editingKey = key.uuid" class="editIconClass"></edit-icon>
                          </div>
                          <div v-else-if="isEditing(key.uuid) || newProfile || isNewRow == key.uuid" class="input-field-wrapper">
                          <input
                                    type="number"
                                    id="date_value"
                                    style="width:35%;position:relative;top:6px"
                                    class="rounded text-light comm-input-field-style"
                                    placeholder="ex: 0"
                                    v-model="key.value['from']"
                                    autocomplete="off"
                          />
                          <span class="key-style"> to</span>
                          <input
                                    type="number"
                                    id="date_value"
                                    style="width:35%;position:relative;top:6px"
                                    class="rounded text-light comm-input-field-style"
                                    placeholder="ex: 10"
                                    v-model="key.value['to']"
                                    autocomplete="off"
                          />
                          <div v-if="(isEditing(key.uuid) || isNewRow == key.uuid) && !newProfile">
                           <save-icon v-on:click.native="saveEditedField(key.value,key.uuid)"></save-icon>
                           <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                          </div>
                          </div>
                        </div>
                        <div v-if="['PICKLIST'].includes(key.type)" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                          <span class="key-style"> contains</span>
                          <div v-if="!isEditing(key.uuid) && !newProfile && isNewRow != key.uuid" class="fields-on-non-edit-mode"  style="margin-top:11px;">
                            <span v-if="selectedPickListNameValues[key.label] != undefined && selectedPickListNameValues[key.label].length == 0"  class="empty-field-text-styles">NONE</span>
                            <div v-else v-for="picklist in selectedPickListNameValues[key.label]" :key="picklist._id" class="tags-style">
                              <div class="user-name-display user-name-display-as-tags">{{picklist.label}}</div>
                            </div>
                            <edit-icon v-on:click.native="editingKey = key.uuid" class="editIconClass"></edit-icon>
                          </div>
                          <div v-else-if="isEditing(key.uuid) || newProfile || isNewRow == key.uuid" class="input-field-wrapper">
                            <Multiselect
                              :value="selectedPickListNameValues[key.label]"
                              :options="getPikListValues(key.label)"
                              :multiple="false"
                              track-by="_id"
                              label="label"
                              :close-on-select="true"
                              :show-no-results="false"
                              deselectLabel =""
                              selectLabel=""
                              selectedLabel=""
                              placeholder="Enter picklist name"
                              :hideSelected="false"
                              :showNoOptions="false"
                              @select="picklistValueTypeOnSelect($event, key.label, key.uuid)">
                              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                              </div>
                              <span slot="noResult">No results</span>
                              <span slot="noOptions" style="display:none"></span>
                            </Multiselect>
                            <div v-if="(isEditing(key.uuid) || isNewRow == key.uuid) && !newProfile">
                              <save-icon v-on:click.native="saveEditedField(selectedPickListNameValues[key.label],key.uuid)"></save-icon>
                              <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                            </div>
                          </div>
                        </div>
                        <div v-if="['PICKLIST_MULTIVALUE'].includes(key.type)" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                          <span class="key-style"> contains</span>
                          <div v-if="!isEditing(key.uuid) && !newProfile && isNewRow != key.uuid" class="fields-on-non-edit-mode"  style="margin-top:11px;">
                            <span v-if="selectedMultiPickListNameValues[key.label] != undefined && selectedMultiPickListNameValues[key.label].length == 0"  class="empty-field-text-styles">NONE</span>
                            <div v-else v-for="picklist in selectedMultiPickListNameValues[key.label]" :key="picklist._id" class="tags-style">
                              <div class="user-name-display user-name-display-as-tags">{{picklist.label}}</div>
                            </div>
                            <edit-icon v-on:click.native="editingKey = key.uuid" class="editIconClass"></edit-icon>
                          </div>
                          <div v-else-if="isEditing(key.uuid) || newProfile || isNewRow == key.uuid" class="input-field-wrapper">  
                            <Multiselect
                              v-model="selectedMultiPickListNameValues[key.label]" 
                              :options="getMultiPikListValues(key.label)"
                              :multiple="true"
                              track-by="_id"
                              label="label"
                              :close-on-select="false"
                              :show-no-results="false"
                              deselectLabel =""
                              selectLabel=""
                              selectedLabel=""
                              :placeholder="$t('Enter picklist name')"
                              :hideSelected="false"
                              :showNoOptions="false"
                              @select="multiPicklistValueTypeOnSelect($event, key.label, key.uuid)"
                              @remove="multiPicklistValueTypeOnRemove($event, key.label,  key.uuid)">
                              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                              <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeMultiPickValCheckBoxSelection(scope.option,key.label)" @focus.prevent :key="scope.option.label"/>
                              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                              </div>
                              <span slot="noResult">No results</span>
                              <span slot="noOptions" style="display:none"></span>
                            </Multiselect>
                            <div v-if="(isEditing(key.uuid) || isNewRow == key.uuid) && !newProfile">
                              <save-icon v-on:click.native="saveEditedField(selectedMultiPickListNameValues[key.label],key.uuid)"></save-icon>
                              <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td title="Delete" style="width:10%">
                      <!-- <svg
                        width="2em"
                        height="1.5em"
                        viewBox="0 0 16 16"
                        class="bi bi-trash delete-btn"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                        />
                        <path
                          fill-rule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                        />
                      </svg> -->
                      <delete-icon class="browse-icon delete-btn"
                        v-if="loadValueType.length > 1"
                        @click.native="deleteLoadType('load_when', key.uuid,key.label)"
                                           style="float: inline-start;text-align: start;margin:8px;height:20px !important;width:20px !important;inset-inline-start:41px;top:6px"
                                           title="Remove Field"></delete-icon>
                    </td>
                  </tr>
                  </template>
                  <tr class="comm-table-row">
                    <td class="text-left" style="width:30%">
                      <div style="" class="add-screens-styles" @click="addSelectedLoadTypePath()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                        </svg>
                        {{$t('Add Filter')}}
                      </div>
                  </td>
                  </tr>
                </tbody>
              </table>
            </li>
          </div>
        </ul>
      </div>
    </div>
    <screen-browser v-if="screenBrowser.isEnabled" :isEditGroup="false"
          :userNameIdMap='selectedScreenIdNameMap'
        @close='handleScreenSelection'></screen-browser>
  </div>
</template>



<script>
import {mapActions,mapGetters} from "vuex";
import DatePicker from "vue2-datepicker";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js";
import Multiselect from 'vue-multiselect';
import CancelIcon from "../core/InlineCancelField.vue";
import ScreenBrowser from "../screens/AddScreenFromBrowser.vue";
import UsersMultiselect  from "../users/UserMultiselectField.vue";
import UserGroupDropdown from "../userGroups/UserGroupSelectionField.vue";
import MultiCatalogDropdown from "../categories/CatalogMultiselectDropdown.vue";
import editIcon from "../core/InlineEditField.vue";
import saveIcon from "../core/InlineSaveField.vue";
import deleteIcon from "../core/InlineDeleteIcon.vue";

export default {
  props: ["selectedScreenProfileID","newProfile", "selectedProfileResp"],
  components:{
    "date-picker":DatePicker,
    "cancel-icon": CancelIcon,
    "Multiselect":Multiselect,
    "screen-browser":ScreenBrowser,
    "users-multiselect":UsersMultiselect,
    "userGroup-dropdown":UserGroupDropdown,
    "multi-catalog-dropdown":MultiCatalogDropdown,
    "edit-icon":editIcon,
    "save-icon":saveIcon,
    "delete-icon":deleteIcon
  },
  data() {
    return {
      fieldInfo:[],
      advancedExp:"",
      pickListNameValues:{},
      selectedPickListNameValues:{},
      selectedMultiPickListNameValues:{},
      loadUuidPickValues:{},
      startupFieldsList:[],
      startUpScreensList:[],
      catalogBrowser:{
        "isEnabled":false,
        "uuid":""
      },
      fieldBrowser:{
        "isEnabled":false,
        "uuid":""
      },
      userGroupBrowser:{
        "isEnabled":false,
        "uuid":""
      },
      screenBrowser:{
        "isEnabled":false,
        "uuid":""
      },
      options:{chunk:5},
      binPermissions: [],
      isModalVisible: false,
      activeField:"",
      route:"",
      categoryDetails:[],
      catalogIdNameMapper:{},
      categoryListFromAutocomplete:[],
      loadValueType:[],
      labelOfLoadTypes:{},
      loadTypes:[
        {label:"",type:Constants.loadEmpty},
        {label:"Catalog",type:Constants.loadWhenCatalog},
        {label:"Mime Type",type:Constants.loadWhenMimeTypes},
        {label:"User",type:Constants.loadWhenUserName},
        {label:"User Group",type:Constants.loadWhenGroupName},
        {label:"Screen",type:Constants.loadWhenScreenName},
        {label:"Advanced Expression", type:Constants.loadWhenAdvancedExp}
      ],
      defaultMimeType:[
        {label:"Image",type:"image"}
      ],
      mimeTypeList:[
        {label:"Image",type:"image"},
        {label:"Video",type:"video"},
        {label:"Audio",type:"audio"},
        {label:"Document",type:"document"},
      ],
      selectedUserGroupIdNameMap:{},
      selectedScreenIdNameMap:{},
      selectedFieldIdNameMap:{},
      userGroupTypes: [],
      userGroupTypesOptions: [],
      screenTypes: [],
      screenTypesOptions:[],
      selectedUsersIdNameMap:{},
      selectedDate:"",
      addedUserGroupList:[],
      editingKey:null,
      isNewRow:null,
      mimeTypeValue:{},
      selectedLoadwhenFilter:[],
      screensIdList:[],
      selectedTime:"",
      selectedDateTime:""
    };
  },
  methods: {
    getSelectedUserIdList(keyUuid){
      let temp = []
      if(keyUuid in this.selectedUsersIdNameMap && this.selectedUsersIdNameMap[keyUuid]){
          for (let op of this.selectedUsersIdNameMap[keyUuid]){
          let indx = temp.filter(u=>u._id == op._id)
          if(indx == -1){
            temp.push(op)
          }
        }
      }
      return temp
    },
      style(name){
          let style = {
          'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
          'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
          }
          return style
      },
      isEditing(keyUuid) {
        return keyUuid === this.editingKey;
      },
      saveFieldComponentsValue(uuid){
        let loadM = this.loadValueType.filter(e => e.uuid == uuid)
          if(loadM != undefined && loadM.length > 0){
            if(loadM[0].type == Constants.loadWhenCatalog){
              let catId =  this.$refs.catalogComponentRef[0].getSelectedCatalogId()
              if(catId != undefined && catId.trim().length > 0){
                loadM[0].id_list = [catId];
                this.updateLoadType("load_when");
              }
            }else if(loadM[0].type == Constants.loadWhenUserName){
                let UserIdLIst = this.$refs.userComponentRef[0].getUserIdNameMap();
                if(UserIdLIst != undefined && UserIdLIst.length > 0){
                  loadM[0].id_list = UserIdLIst;
                  this.updateLoadType("load_when");
                }
            }
            else if(loadM[0].type == Constants.loadWhenGroupName){
              let UserGroupIdLIst = this.$refs.userGroupComponentRef[0].getSelectedGroupIdsList();
                if(UserGroupIdLIst != undefined && UserGroupIdLIst.length > 0){
                  loadM[0].id_list = UserGroupIdLIst;
                  this.updateLoadType("load_when");
                }
            }
            else if(loadM[0].type == Constants.loadWhenScreenName){
              if(this.screensIdList != undefined && this.screensIdList.length){
                  loadM[0].id_list = this.screensIdList;
                  this.updateLoadType("load_when");
              }
            }
            else if(loadM[0].type == Constants.loadWhenAdvancedExp){
              if(this.advancedExp != undefined && this.advancedExp.length){
                  loadM[0].id_list = [this.advancedExp];
                  this.updateLoadType("load_when");
              }
            }
            this.editingKey = null;
            this.isNewRow = null;
          }
      },
      saveEditedField(fieldValue,uuid){
        if(typeof fieldValue == "undefined"){
          alert("Please add valid value")
          return;
        }
        let loadM = this.loadValueType.filter(e => e.uuid == uuid);
          if(loadM[0] != undefined && loadM.length > 0){
            if(loadM[0].type == Constants.loadWhenMimeTypes){
              if(Object.keys(this.mimeTypeValue).length && this.mimeTypeValue.type != undefined && this.mimeTypeValue.type.length){
                loadM[0].value = this.mimeTypeValue.type;
              }
              else{
                alert("Please select valid mime type");
                return;
              }
            }
            else if(this.isFieldType(loadM[0].type)){
              if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(loadM[0].type)){
                let MValue = [];
                  for(let e of fieldValue){
                    if(e.label != undefined){
                      MValue.push(e._id)
                    }
                  }
                  if(MValue.length <= 0){
                    alert("Please add atleast one value")
                    return;
                  }
                  loadM[0].value = MValue;
              }else if(loadM[0].type == "INTEGER"){
                loadM[0].value = fieldValue;
              }else if(fieldValue != undefined && fieldValue.length){
                if(loadM[0].type == "DATE_TIME"){
                  fieldValue[0] = fieldValue[0].replace(" ","T");
                  fieldValue[1] = fieldValue[1].replace(" ","T");
                }
                loadM[0].value = fieldValue;
              }else{
                let mssg = "Please add valid value"
                if(["FREETEXT","FREETEXT_MULTILINE"].includes(loadM[0].type)){
                  mssg = "Please select valid text"
                }else if(loadM[0].type == "INTEGER"){
                  mssg = "Please select valid number"
                }else if(loadM[0].type == "date"){
                  mssg = "Please add valid date"
                }else if(loadM[0].type == "DATE_TIME"){
                  mssg = "Please add valid date time"
                }else if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(loadM[0].type)){
                  mssg = "Please add valid field values"
                }
                  alert(mssg);
                  return;
                
              }
            }
          }
        if(fieldValue != undefined){
          this.updateLoadType("load_when");
        }
        this.editingKey = null;
        this.isNewRow = null;
      },
      selectionLabelCallback(option){
        if(option != undefined && option.labeled_pid_tree != undefined){
          let temp = option.labeled_pid_tree.split(">");
          let temp2 = temp.pop();
          return `${temp2 + '[' +temp.join(">") + ']'}`
        }
        return option;
      },
      // optionsOnSelectCallback(option, loadCUuid){
      //   let index = this.categoryListFromAutocomplete.findIndex(item => item.label == option.label);
      //   this.searchKey = this.categoryListFromAutocomplete[index];
      //   this.storeCategory(option._id, option.labeled_pid_tree, loadCUuid, true);
      // },
      updatedSelectedCatalog(option, loadCUuid){
        let index = this.categoryListFromAutocomplete.findIndex(item => item.label == option.label);
        this.searchKey = this.categoryListFromAutocomplete[index];
        this.storeCategory(option._id, option.labeled_pid_tree, loadCUuid, true);
      },
      displayOptionsOnSearch(searchedKey){
          let payload = {};
            payload.params = {catalog_name:searchedKey};
            this.getAllAssetsFromServer(payload).then((data)=>{
              this.$nextTick(()=>{
                let responseData = data.assets;
                for(let i = 0; i < responseData.length; i++){
                  let temp = responseData[i].labeled_pid_tree.split(">");
                  let temp2 = temp.pop();
                  responseData[i].label = `${temp2 + ' [' +temp.join(">")+ ']'}`;
                }
                this.categoryListFromAutocomplete = responseData;
              })
            });
      },
        getLabelName(tUuid){
          let temp = this.labelOfLoadTypes.filter(t=>t.uuid==tUuid);
          if(temp != undefined && temp.length){
            return {"label":temp[0].label};
          }
          return ""
        },
        isFieldType(fieldType){
          return ["FREETEXT","FREETEXT_MULTILINE","DATE","DATE_TIME","INTEGER","PICKLIST","PICKLIST_MULTIVALUE"].includes(fieldType);
        },
        updateRowType(newVal,oldVal){
          if(typeof newVal != "undefined" && typeof oldVal != "undefined"){
            let oldValLabel = oldVal.label
            if(this.selectedLoadwhenFilter.includes(newVal.label)){
              alert("Already selected");
              return;
            }
            let isTypeExists = false;
            for(let loadType of this.loadValueType){
              if(loadType.uuid == oldVal.uuid){
                isTypeExists = true;
                loadType.type = newVal.type;
                loadType.label = newVal.label;
                this.isNewRow = loadType.uuid;
                this.labelOfLoadTypes[loadType.uuid] = {"label":newVal.label};
                if(this.selectedLoadwhenFilter.includes(oldValLabel)){
                  this.selectedLoadwhenFilter.splice(this.selectedLoadwhenFilter.indexOf(oldValLabel), 1);
                }
                this.selectedLoadwhenFilter.push(newVal.label);
                if(this.isFieldType(newVal.type) && Object.keys(newVal).includes("key_id")){
                  loadType.id_list = [newVal.key_id];
                  if(newVal.type == 'INTEGER'){
                    loadType.value={
                      'from':0,
                      'to':1
                    }
                  }else if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(newVal.type)){
                    loadType.value=[]
                  }else{
                    loadType.value = ""
                  }
                }
              }
            }
            if(!isTypeExists){
              let newUuid = Utils.getUUID();
              this.labelOfLoadTypes[newUuid] = {"label":newVal.label};
              let newEntry = {
                "type":newVal.type,
                "uuid":newUuid,
                "label":newVal.label
              }
              if(this.isFieldType(newVal.type) && Object.keys(newVal).includes("key_id")){
                  newEntry.id_list = [newVal.key_id];
                  newEntry.value = ""
              }else{
                newEntry.value = ""
              }
              this.selectedLoadwhenFilter.push(newVal.label);
              this.loadValueType.push(newEntry);
              this.isNewRow = newUuid;
            }
          }
        },
        addSelectedLoadTypePath(){
          let newUuid = Utils.getUUID();
          this.labelOfLoadTypes[newUuid] = "";
          this.loadValueType.push({
            "type":Constants.loadEmpty,
            "id_list":[],
            "uuid":newUuid,
            "label":""
          })
        },
        getLoadWhenDetails(){
          for(let loadT of this.loadValueType){
            if(this.advancedExp != undefined && this.advancedExp.trim().length){
              if(loadT.type == Constants.loadWhenAdvancedExp){
                loadT.id_list = [this.advancedExp];
              }
            }
            if(loadT.type == Constants.loadWhenUserName){
              let UserIdLIst = this.$refs.userComponentRef[0].getUserIdNameMap();
              if(UserIdLIst != undefined && UserIdLIst.length){
                loadT.id_list = UserIdLIst;
              }
            }
            if(loadT.type == Constants.loadWhenGroupName){
              let UserGroupIdLIst = this.$refs.userGroupComponentRef[0].getSelectedGroupIdsList();
              if(UserGroupIdLIst != undefined && UserGroupIdLIst.length){
                loadT.id_list = UserGroupIdLIst;
              }
            }
            if(loadT.type == Constants.loadWhenCatalog){
              let catId =  this.$refs.catalogComponentRef[0].getSelectedCatalogId()
              if(catId != undefined && catId.length > 0){
                loadT.id_list = catId;
              }
            }
            if(loadT.type == Constants.loadWhenScreenName){
              if(this.screensIdList != undefined && this.screensIdList.length){
                  loadT.id_list = this.screensIdList;
              }
            }
            if(loadT.type == "DATE_TIME"){
              loadT.value[0] = loadT.value[0].replace(" ","T");
              loadT.value[1] = loadT.value[1].replace(" ","T");
            }
          }

          let loadWDList = this.loadValueType.filter(t=>(t.id_list.length > 0 || (t.type == Constants.loadWhenMimeTypes && t.value.length > 0)) );
          if(loadWDList != undefined && loadWDList.length > 0){
            return loadWDList;
          }
          return [];
        },
        updateLoadType(loadType){
            if(this.newProfile){
                return
            }
            let payload = {};
            if(loadType == "load_when"){
              payload.load_when = this.loadValueType;
            }
            payload.params = { _id: this.selectedScreenProfileID };
            this.updateExistingMetadataProfile(payload).then((data) => {
                if (Utils.isAcceptedStatusCode(data.statusCode)){
                  this.$toast.success(data.message);
                  this.editingKey = null;
                  this.isNewRow = null;
                } else {
                  this.$toast.error(data.message);
                }
            });
        },
        deleteLoadType(loadType, loadTypeUuid,label){
          if(typeof loadType == "undefined"){
            return;
          }
           if(loadType == "load_when"){
              if(this.selectedLoadwhenFilter.includes(label)){
                this.selectedLoadwhenFilter.splice(this.selectedLoadwhenFilter.indexOf(label), 1);
              }
              let tIndex = this.loadValueType.findIndex(t=>t.uuid==loadTypeUuid);
              this.loadValueType.splice(tIndex,1);
              if(label.trim().length > 0){
                this.loadValueType = this.loadValueType.filter(op=> op.type != Constants.loadEmpty)
                this.updateLoadType("load_when");
              }
            }
        },
        
        //user id's Operations
        handleUpdatedUsersList(userId,FUuid){
          if(userId != undefined){
            let findType = this.loadValueType.filter(loadU=>loadU.uuid == FUuid && !loadU.id_list.includes(userId));
                if(findType != undefined && findType.length){
                    findType[0].id_list.push(userId);
                    this.updateLoadType("load_when");
                  }
          }
        },
        handleRemovedUserFromList(userId,FUuid){
          if(userId != undefined){
            for(let loadU of this.loadValueType){
                if(loadU.uuid == FUuid && loadU.id_list.includes(userId)){
                  loadU.id_list.splice(loadU.id_list.indexOf(userId),1);
                  this.updateLoadType("load_when");
                  break;
                }
               }
           }
        },
        updateUsersList(isPageClick = false){
            let payload={}
            let paramsInfo = {}
            if(isPageClick){
                paramsInfo['page'] = this.page
            }
            paramsInfo.filter=JSON.stringify(["username"])
            paramsInfo.limit=Constants.usersRecordsLimit;
            payload = {params:paramsInfo}
            this.getAllUsersFromServer(payload).then((data) => {
                this.totalPages = data["page_count"];
                this.page = data["page"];
                this.totalTags = data["total_users"];
                this.perPage = data["users_per_page"];
                this.usersList = data["users"];
            });
        },
        //
        //user group id's Operations
        handleUpdatedUserGroupList(groupId,FUuid){
          if(groupId != undefined){
            let findType = this.loadValueType.filter(loadU=>loadU.uuid == FUuid && !loadU.id_list.includes(groupId));
                if(findType != undefined && findType.length){
                    findType[0].id_list.push(groupId);
                    this.updateLoadType("load_when");
                  }
          }
        },
        handleRemovedUserGroupFromList(groupId,FUuid){
          if(groupId != undefined){
            for(let loadU of this.loadValueType){
                if(loadU.uuid == FUuid && loadU.id_list.includes(groupId)){
                  loadU.id_list.splice(loadU.id_list.indexOf(groupId),1);
                  this.updateLoadType("load_when");
                  break;
                }
               }
           }
        },
        updateUserGroupsList(){
          this.getAllUserGroupsFromServer().then((data) => {
              this.userGroupsList = data["user_groups"];
              this.userGroupTypesOptions = data["user_groups"];
          });
        },
        //
        //screen id's Operations
        handleScreenSelection(screenIds, screenIdNameMap){
          this.$refs.fadeWhenModelOpen.style.opacity = 1;
          if(screenIds == undefined){
            this.screenBrowser = {
              "isEnabled":false,
              "uuid":""
            };
            return;
          }
          for(let groupId of Object.keys(screenIdNameMap)){
            if(!Object.keys(this.selectedScreenIdNameMap).includes(groupId)){
              this.selectedScreenIdNameMap[groupId] = screenIdNameMap[groupId];
            }
          }
          for(let screenId of screenIds){
            for(let loadS of this.loadValueType){
              if(loadS.uuid == this.screenBrowser.uuid && !loadS.id_list.includes(screenId)){
                loadS.id_list.push(screenId);
                break;
              }
            }
          }
          this.screenBrowser = {
            "isEnabled":false,
            "uuid":""
          };
          this.updateLoadType("load_when");
        },
        getScreenNamefromId(screenId){
          if(Object.keys(this.selectedScreenIdNameMap).includes(screenId)){
            return this.selectedScreenIdNameMap[screenId];
          }
          return "None";
        },
        deleteScreenIdFromList(screenId,loadSUuid){
          for(let loadS of this.loadValueType){
            if(loadS.uuid == loadSUuid && loadS.id_list.includes(screenId)){
                loadS.id_list.splice(loadS.id_list.indexOf(screenId),1);
                break;
            }
          }
          this.updateLoadType("load_when");
        },
        enableScreenBrowser(keyUuid){
          this.screenBrowser={
            "isEnabled":true,
            "uuid":keyUuid
          }
          this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
        },
        screenTypeLabelCallback(option){
          return `${option.name}`
        },
        getscreensOnKeyup(option){
          if (!this.startUpScreensList.length) {
              return [];
            }
            if(typeof(option) != "undefined" && option.trim().length > 0){
              this.screenTypesOptions =  this.startUpScreensList.filter((item) => {
                const screenName = item.name.toLowerCase();
                const searchTerm = option.toLowerCase();
                return screenName.includes(searchTerm);
              });
            }else if(option.length==0){
              this.screenTypesOptions = this.startUpScreensList;
            }
            return this.screenTypesOptions;
        },
        screenTypeOnSelect(option){
          let index = this.screenTypesOptions.findIndex(item => item._id == option._id);
          if(index > -1){
              this.screenTypesOptions[index].checked = true;
              this.selectedScreenIdNameMap[option._id] = option.name;
              this.screensIdList.push(option._id)
              // let findType = this.loadValueType.filter(loadU=>loadU.uuid == FUuid && !loadU.id_list.includes(option._id));
              // if(findType != undefined && findType.length){
              //     findType[0].id_list.push(option._id);
              //     this.updateLoadType("load_when");
              //   }
          }
        },
        screenTypeOnRemove(option){
          let index = this.screenTypesOptions.findIndex(item => item._id == option._id);
          if(index > -1){
              this.screenTypesOptions[index].checked = false;
              this.screensIdList = this.screensIdList.filter(e => e != option._id)
              // for(let loadU of this.loadValueType){
              //   if(loadU.uuid == FUuid && loadU.id_list.includes(option._id)){
              //     loadU.id_list.splice(loadU.id_list.indexOf(option._id),1);
              //     this.updateLoadType("load_when");
              //     break;
              //   }
              // }
          }
        },
        makeScreensCheckBoxSelection(option){
            return this.screenTypes.some((op) => op._id === option._id);
        },
        //
        //picklist val
        getPikListValues(FLabel){
          return this.pickListNameValues.filter(item=>item.PLabel == FLabel);
        },
        getMultiPikListValues(FLabel){
          return this.multiPickListNameValues.filter(item=>item.PLabel == FLabel);
        },
        picklistValueTypeOnSelect(option,FLabel,FUuid){
          let index = this.pickListNameValues.findIndex(item => item._id == option._id && item.PLabel == FLabel);
          if(index > -1){
            this.pickListNameValues[index].checked = true;
            this.$set(this.selectedPickListNameValues, FLabel, option)
            let findType = this.loadValueType.filter(loadU=>loadU.uuid == FUuid);
            if(findType != undefined && findType.length){
              findType[0].value = [option._id];
              this.updateLoadType("load_when");
            }
          }
        },
        multiPicklistValueTypeOnSelect(option,FLabel,FUuid){
          let index = this.multiPickListNameValues.findIndex(item => item._id == option._id && item.PLabel == FLabel);
          if(index > -1){
            this.multiPickListNameValues[index].checked = true;
            let findType = this.loadValueType.filter(loadU=>loadU.uuid == FUuid && !loadU.value.includes(option.label));
            if(findType != undefined && findType.length){
              findType[0].value.push(option._id);
            }
          }
        },
        multiPicklistValueTypeOnRemove(option,FLabel,FUuid){
          let index = this.multiPickListNameValues.findIndex(item => item._id == option._id && item.PLabel == FLabel);
          if(index > -1){
              this.multiPickListNameValues[index].checked = false;
              let findType = this.loadValueType.filter(loadU=>loadU.uuid == FUuid && loadU.value.includes(option._id));
              if(findType != undefined && findType.length){
                findType[0].value.splice(findType[0].value.indexOf(option._id),1);
              }
          }
         },
        makeMultiPickValCheckBoxSelection(option,FLabel){
          if(Object.keys(this.selectedMultiPickListNameValues).includes(FLabel)){
            return this.selectedMultiPickListNameValues[FLabel].some((op) => op._id === option._id);
          }else{
            return false;
          }
        },
        picklistTypeValueCallback(option){
          return `${option.label}`
        },
        //
        //field id's Operations
        getLoadWhenFieldIds(){
          for(let loadF of this.loadValueType){
            if(loadF.uuid == this.fieldBrowser.uuid){
              return loadF.id_list;
            }
          }
          return [];
        },
        getFieldNamefromId(fieldId){
          if(Object.keys(this.selectedFieldIdNameMap).includes(fieldId)){
            return this.selectedFieldIdNameMap[fieldId];
          }
          return "None";
        },
        deleteFieldIdFromList(fieldId, loadFUuid){
          for(let loadF of this.loadValueType){
            if(loadF.uuid == loadFUuid){
                let findIndex = loadF.id_list.findIndex(t=>t.id==fieldId);
                loadF.id_list.splice(findIndex,1);
                break;
            }
          }
          this.updateLoadType("load_when");
        },
        enableFieldBrowser(keyUuid){
          this.fieldBrowser={
            "isEnabled":true,
            "uuid":keyUuid
          }
          this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
        },
        //
        //mime type Operations
          updateMimeType(mimeTypeDetails,loadMUuid){
            if(this.isNewRow != null){
               if(typeof mimeTypeDetails == "undefined"){
                return;
              }
              this.defaultMimeType = mimeTypeDetails;
              this.mimeTypeValue = mimeTypeDetails
              for(let loadM of this.loadValueType){
                if(loadM.uuid == loadMUuid){
                  loadM.value = mimeTypeDetails.type;
                  break;
                }
              }
              // if(mimeTypeDetails.type != undefined && mimeTypeDetails.type.trim().length > 0){
              //   this.updateLoadType("load_when");
              // }
            }else{
              this.mimeTypeValue = mimeTypeDetails;
              for(let loadM of this.loadValueType){
                if(loadM.uuid == loadMUuid){
                  loadM.value = mimeTypeDetails.type;
                  break;
                }
              }
              this.editingKey =  mimeTypeDetails.type;
              }
          },
        //
        //Catalog Operations
        enableCatalogBrowser(keyUuid){
          this.$emit("fadePage",0.2);
          this.catalogBrowser={
            "isEnabled":true,
            "uuid":keyUuid
          }
        },
          getCategoriesOnKeyup(fieldUuid){
            let payload = {};
            payload.params = {catalog_name:this.catalogIdNameMapper[fieldUuid]};
            this.getAllAssetsFromServer(payload).then((data)=>{
              let catalogExists= false;
              for(let catalog of this.categoryListFromAutocomplete){
                if(catalog.uuid == fieldUuid){
                  catalog.catalogs = data.assets;
                }
              }
              if(!catalogExists){
                this.categoryListFromAutocomplete = [{
                  "uuid":fieldUuid,
                  "catalogs":data.assets
                }]
              }
            });
          },
          storeCategory(id,name, loadTypeUuid, profileEdited){
            let isCatExists = false;
            this.catalogIdNameMapper[loadTypeUuid]=name;
            for(let cat of this.categoryDetails){
              if(cat.uuid == loadTypeUuid){
                isCatExists = true;
                cat.id = id;
              }
            }
            if(!isCatExists){
              this.categoryDetails.push({
                "id":id,
                "uuid":loadTypeUuid
              })
            }
            isCatExists = false;
            for (let loadTypeVal of this.loadValueType) {
                if(loadTypeVal.uuid == loadTypeUuid){
                  isCatExists = true;
                  loadTypeVal.id_list = [id];
                  break;
                }
            }
            if(!isCatExists){
              this.loadValueType.push({
                "type":Constants.loadWhenCatalog,
                "id_list":[id],
                "uuid":loadTypeUuid
              })
            }
            for(let cat of this.categoryListFromAutocomplete){
              if(cat.uuid == loadTypeUuid){
                cat.catalogs=[];
              }
            }
            if(profileEdited){
              this.updateLoadType("load_when");
            }
          },
          refreshSelectedCatalog(fieldUUId){
            let loadM = this.loadValueType.filter(e => e.uuid == fieldUUId)
            if(loadM != undefined && loadM.length > 0){
              if(loadM[0].type == Constants.loadWhenCatalog){
                let catId =  this.$refs.catalogComponentRef[0].getSelectedCatalogId()
                if(catId != undefined && catId.length > 0){
                  loadM[0].id_list = catId;
                  this.updateLoadType("load_when");
                }else{
                  alert("Please add valid value");
                  return;
                }
              }
            }
          },
          getCategoryRoutefromId(categoryId, browserUuid){
            let catId = categoryId;
              catId = categoryId.parent_id_path;
            if (typeof catId != "undefined" && catId && catId.length > 0){
                let isCatalogExists = false;
                this.catalogIdNameMapper[browserUuid] = (catId.catalog_name + " [ " + catId.parent_path[0].value.replace("catalog://0","") + "] ");
                for(let cat of this.categoryDetails){
                  if(cat.uuid == browserUuid){
                    cat.id = catId;
                    isCatalogExists = true;
                  }
                }
                if(!isCatalogExists){
                  this.categoryDetails.push({
                    "id":catId._id,
                    "uuid":browserUuid
                  })
                }
                isCatalogExists = false;
                for (let loadTypeVal of this.loadValueType) {
                  isCatalogExists = true;
                  if(loadTypeVal.uuid == browserUuid){
                    loadTypeVal.id_list = [catId._id];
                    loadTypeVal.type = Constants.loadWhenCatalog;
                    break;
                  }
                }
                if(!isCatalogExists){
                  this.loadValueType.push({
                    "type":Constants.loadWhenCatalog,
                    "id_list":[catId._id],
                    "uuid":browserUuid
                  })
                }
                this.route = catId;
                this.catalogBrowser = {
                  "isEnabled":false,
                  "uuid":""
                }
                this.updateLoadType(Constants.loadWhenCatalog);
            } 
            return this.route
          },
          closeCatalogBrowse(){
              this.catalogBrowser = {
                "isEnabled":false,
                "uuid":""
              };
          },
          isFieldExists(fieldId){
            let idx = this.startupFieldsList.findIndex(item=>item._id == fieldId);
            if(idx >= 0){
              return true;
            }
            return false;
          },
          cancelEditMode(){
            this.editingKey = null;
            this.isNewRow = null;
          },
          reloadFilters(){
          // let payload = {};
          // payload.params = { _id: this.selectedScreenProfileID };
          // this.getMetadataProfileInfoFromServer(payload).then((resp) => {
            this.loadWhen = this.selectedProfileResp["metadata_profile"]["load_when"];
            if(Object.keys(this.selectedProfileResp).includes("user_group_info") && this.selectedProfileResp.user_group_info.length > 0){
              this.addedUserGroupList = this.selectedProfileResp.user_group_info;
            }
            this.loadValueType = this.selectedProfileResp.metadata_profile["load_when"];
            this.postData = this.selectedProfileResp.metadata_profile;
            if(typeof this.loadValueType != "undefined" && this.loadValueType.length > 0){
              for(let loadC of this.loadValueType){
                this.labelOfLoadTypes[loadC.uuid] = {"label":loadC.label};
                this.selectedLoadwhenFilter.push(loadC.label);
                if(loadC.id_list == undefined && loadC.id_list.length <= 0){
                  continue;
                }
                if(loadC.type == Constants.loadWhenCatalog){
                  this.categoryDetails.push({
                    "id":"",
                    "uuid":loadC.uuid
                  });
                  if(loadC.id_list != undefined &&loadC.id_list.length > 0){
                    // let catalogPath = "";
                    // for(let cId of loadC.id_list){
                    //   let catDetails = resp.category_info.filter(c=>c.category_id== cId);
                    //   if(catDetails != undefined && catDetails.length > 0){
                    //     catalogPath = catDetails[0].name;
                    //     if(catalogPath != undefined){
                    //       console.log("111111111111111111111111111111111111111111111111111111111111",catalogPath,"uiiiiiiidddd",loadC.uuid)
                    //       // this.catalogIdNameMapper[loadC.uuid] = loadC;
                    //       this.storeCategory(cId, catalogPath, loadC.uuid, false);
                    //       // this.$refs.catalogComponentRef.setCatalogData(cId,catalogPath,loadC.uuid)
                    //     }
                    //     this.categoryDetails.push({
                    //       "id":cId,
                    //       "uuid":loadC.uuid
                    //     })
                    //   }
                    // }
                  }
                }else if(this.isFieldType(loadC.type)){
                  for(let fId of loadC.id_list){
                    let fDetails = this.startupFieldsList.filter(f=>f._id == fId);
                    if(fDetails != undefined && fDetails.length > 0){
                      let filedMapperBasedName = this.getCustomMetadataName(fDetails[0])
                      loadC['label'] = filedMapperBasedName;
                      this.labelOfLoadTypes[loadC.uuid] = {"label":filedMapperBasedName};
                      this.selectedLoadwhenFilter.push(filedMapperBasedName);
                      this.selectedFieldIdNameMap[fId] = filedMapperBasedName;
                      if(['PICKLIST_MULTIVALUE'].includes(fDetails[0].type)){
                        let tempValList = [];
                        for(let pickVal of loadC.value){
                          let valInfo = fDetails[0].values.filter(op=>op.value_id == pickVal);
                          if(valInfo.length > 0){
                            tempValList.push({
                              "_id":valInfo[0].value_id,
                              "label":valInfo[0].value,
                              "PLabel":filedMapperBasedName,
                              "checked":true
                            })
                          }
                        }
                        // this.selectedMultiPickListNameValues[fDetails[0].name] = tempValList;
                        this.$set(this.selectedMultiPickListNameValues, filedMapperBasedName, tempValList)
                      }else if(['PICKLIST'].includes(fDetails[0].type)){
                        let tempValList = [];
                        for(let pickVal of loadC.value){
                          let valInfo = fDetails[0].values.filter(op=>op.value_id == pickVal);
                          if(valInfo.length > 0){
                            tempValList.push({
                              "_id":valInfo[0].value_id,
                              "label":valInfo[0].value,
                              "PLabel":filedMapperBasedName,
                              "checked":true
                            })
                          }
                        }
                        this.$set(this.selectedPickListNameValues, filedMapperBasedName, tempValList)
                      }else if(["DATE"].includes(fDetails[0].type)){
                        this.selectedTime = loadC.value;
                      }else if(["DATE_TIME"].includes(fDetails[0].type)){
                        let sDT = loadC.value;
                        sDT[0] = sDT[0].replace("T", " ");
                        sDT[1] = sDT[1].replace("T", " ");
                        this.selectedDateTime = sDT;
                      }
                    }
                  }
                }else if(loadC.type == Constants.loadWhenMimeTypes){
                  let MTList = ""
                  Object.assign(MTList, loadC.id_list[0]);
                  this.defaultMimeType = {
                    type: MTList,
                    label:MTList.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })
                    }
                  this.mimeTypeValue = {
                    type: MTList,
                    label:MTList.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })
                    }
                }else if(loadC.type == Constants.loadWhenUserName){
                  this.selectedUsersIdNameMap[loadC.uuid] = []
                  let usermapList = []
                  for(let uId of loadC.id_list){
                    let uInfo = this.selectedProfileResp.user_info.filter((u)=>u.user_id == uId);
                    if(uInfo != undefined && uInfo.length){
                      usermapList.push({
                        "_id":uInfo[0].user_id,
                        "username":uInfo[0].name,
                        "checked":true
                      })
                    }
                  }
                  this.selectedUsersIdNameMap[loadC.uuid] = usermapList;
                }else if(loadC.type == Constants.loadWhenGroupName){
                  this.userGroupTypes = []
                  for(let uGInfo of this.selectedProfileResp.user_group_info){
                    this.selectedUserGroupIdNameMap[uGInfo.user_group_id] = uGInfo.name;
                    this.userGroupTypes.push({
                      "_id":uGInfo.user_group_id,
                      "group_name":uGInfo.name,
                      "checked":true
                    })
                  }
                }else if(loadC.type == Constants.loadWhenScreenName){
                  this.screenTypes = []
                  this.screensIdList = []
                  for(let sId of loadC.id_list){
                    let sDetails = this.startUpScreensList.filter(f=>f._id == sId);
                    if(sDetails != undefined && sDetails.length > 0){
                      this.screensIdList.push(sId);
                      this.selectedScreenIdNameMap[sId] = sDetails[0].name;
                      this.screenTypes.push({
                      "_id":sId,
                      "name":sDetails[0].name,
                      "checked":true
                    })
                    }
                  }
                }else if(loadC.type == Constants.loadWhenAdvancedExp){
                  this.advancedExp = loadC.id_list[0]
                }
              }
            }
          // });
          },
        //

          getCustomMetadataName(fieldInfo){
            if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
              let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
              if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
                return mapperExists.field_alias;
              }
            }
            return fieldInfo.name;
          },
        ...mapActions("userGroups", ["getAllUserGroupsFromServer","updateExistingUserGroup"]),
        ...mapActions("users",["getUsersAutoComplitionFromServer","getAllUsersFromServer","getUserInfoFromServer","updateExistingUser","checkUserLoginStatus"]),
        ...mapActions("metadataProfiles",["updateExistingMetadataProfile","getMetadataProfileInfoFromServer"]),
        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
        ...mapActions("assets",["getCategoryTreefromId"]),
  },
  watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
          document.getElementById("folderNameField").focus();
          this.userTypesOptions = [];
        })
      }
    },
    'selectedProfileResp': function(val){
      if(val){
        this.reloadFilters()
      }
    }
  },
  created(){
    if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
        this.startupFieldsList = this.getStartUpDataFromInCache()["custom_metadatas"];
        if(this.startupFieldsList != undefined){
          let tempMultiValList = [];
          let tempValList = [];
          for(let fDetails of this.startupFieldsList){
            let fieldName = this.getCustomMetadataName(fDetails)
            if(['PICKLIST_MULTIVALUE'].includes(fDetails.type)){
              for(let pickVal of fDetails.values){
                tempMultiValList.push({
                  "_id":pickVal.value_id,
                  "label":pickVal.value,
                  "PLabel":fieldName
                })
              }
            }else if(['PICKLIST'].includes(fDetails.type)){
              for(let pickVal of fDetails.values){
                tempValList.push({
                  "_id":pickVal.value_id,
                  "label":pickVal.value,
                  "PLabel":fieldName
                })
              }
            }
            this.loadTypes.push({
              "label":fieldName,
              "type":fDetails.type,
              "key_id":fDetails._id
            })
          }
          this.multiPickListNameValues = tempMultiValList;
          this.pickListNameValues = tempValList;
        }
    }if(Object.keys(this.getStartUpDataFromInCache()).includes("screens")){
        this.startUpScreensList = this.getStartUpDataFromInCache()["screens"];
         this.screenTypesOptions = this.getStartUpDataFromInCache()["screens"];
    }
    if(!this.newProfile){
      this.reloadFilters()
    }else{
      this.selectedLoadwhenFilter.push('Catalog');
      let defaultLoadTypeUuid = Utils.getUUID();
      this.labelOfLoadTypes[defaultLoadTypeUuid] = {"label":"Catalog"};
      this.loadValueType.push({
        "type":Constants.loadWhenCatalog,
        "id_list":[],
        "label":"Catalog",
        "uuid":defaultLoadTypeUuid
      });
      this.categoryDetails.push({
        "id":"",
        "uuid":defaultLoadTypeUuid
      });
      this.catalogIdNameMapper[defaultLoadTypeUuid]="";
    }
    this.updateUsersList(false);
    this.updateUserGroupsList();
    if(Object.keys(this.getStartUpDataFromInCache()).includes("CATALOG_READ_ONLY") && this.getStartUpDataFromInCache().CATALOG_READ_ONLY){
      this.loadTypes = this.loadTypes.filter(e => e.type != Constants.loadWhenCatalog);
    }
  },
};
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $border-on-hover: 1px solid #61707d;
    $add-button-text-color:#666;
    $add-button-text-color-hover:#eee;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;


.empty-field-text-styles{
  color:$none-text-color;
}

.input-field-wrapper{
    display: inline-flex;
    width: 100%;
    position: relative;
    svg{
      position: absolute;
      inset-inline-end: -27px;
      top: 12px;
      height:25px;
    }
}

.fields-on-non-edit-mode{
  width:70%;
  // display:inline-flex;
  line-height:46px;
  text-align: start;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
    input[type="checkbox"]:after {
        line-height: 1.5em;
        content: "";
        display: inline-block !important;
        width: 22px !important;
        height: 21px !important;
        margin-top: 5px !important;
        margin-inline-start: -1px !important;
        border: $border-color !important;
        border-radius: 0.25em !important;
        background: $primary-background !important;
    }
    input[type="checkbox"]:checked:after {
        content: "✔";
        color: $active-blue !important;
        position: absolute !important;
        font-size: 16px !important;
        line-height: 1 !important;
        transition: all 0.2s !important;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px !important;
        padding-top: 2px !important;
    }

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
}

.tags-display-ul{
  list-style-type: none;
}

.tags-display-ul .show-tags-delete{
  visibility:hidden;
}

.searched-metadata-display-fields{
  height: auto;
  width: 90%;
}

.view-tags:hover .show-tags-delete{
  visibility: visible;
}

.view-tags:hover {
  border: $border-on-hover !important;
}

.key-style {
  color: $dull-text-color;
  width: 30%;
  text-align: center;
  font-size: $input-field-and-label-font-size;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  margin-top: 13px;
}

.activeTag{
    color: $active-blue !important;
}
.view-tags{
      font-size: 12px;
      height: 24px;
      display: inline-flex;
      margin:2px !important;
      border: $border-color !important;
      border-radius: 15px !important;
      min-width: 50px;
      padding: 0px !important;
      text-align: center;
      width:auto !important;
      padding-inline-start: 12px !important;
      justify-content: center;
      padding-top: 1px !important;
      div{
              padding: 0px 8px;
              margin-inline-start: 0px;
              font-size: 12px;
              border-radius: 15px !important;
              position: relative;
              top: 1px;
      }
    }

  .view-fields-styles{
    font-size: 12px;
    height: 24px;
    display: inline-flex;
    margin:2px !important;
    border-radius: 15px !important;
    min-width: 50px;
    padding: 0px !important;
    text-align: start;
    width:98% !important;
    padding-inline-start: 12px !important;
    justify-content: start;
    padding-top: 1px !important;
    div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 14px;
            line-height: 32px;
            color: $secondary-text-color;
            text-align:end;
    }
  }

  .comm-input-field-style{
    background: $primary-background!important;
    width: 100%;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: 42px;
}

.comm-tags-field-wrapper-style{
    background: $primary-background!important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    min-height: $input-field-height;
    margin-top:1px;
    margin-bottom:1px;
    border-radius: 4px;
}

::v-deep{
    .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
        background: $primary-background;
        border-bottom: $border-color;
    }
    .mx-input{
        background-color: $primary-background  !important;
        border: none !important;
        color: $text-color !important;
    }
    .mx-datepicker-main{
        border: $border-color !important;
        background: $secondary-background-color !important;
    }
    .mx-calendar-content .cell:hover{
        background-color: $bg-color-on-hover !important;
    }
    .mx-datepicker-range{
        width:auto;
    }
    .mx-calendar-content .cell:hover {
        color: #000000;
        background-color: #7d99b1;
    }
    .mx-icon-calendar{
        color:$text-color;
    }
}

.value-style{
  width: 98%;
  text-align: start;
  padding-top: 0px;
  padding-bottom: 3px;
  padding-inline-end: 5px;
  .slug-ellipsis{
      white-space: nowrap;
      max-width: 350px;
      overflow: hidden;
      text-overflow: ellipsis;
  }
}
.input-fields{
    border: none;
    border-radius: 0px !important;
    // margin-inline-start:5px;
    // margin-bottom: 7px;
}

.input-fields:focus{
    outline: unset;
    border-bottom: 1px solid #0373ee !important;
}

.focusField{
    input:focus, select:focus{
    border:none !important;
  }
}

.tags-wrapper{
  position: absolute;
  inset-inline-end: 0px;
}



svg {
  color: #666666;
}

svg:hover {
  color: $text-color;
}

.table-scroll {
    /*width:100%; */
    border: none !important;
    /* Decoration */
    border-spacing: 0;
    width: 100%;
    thead {
        color: $dull-text-color !important;
        position: relative;
        th{
        position: sticky;
        top: 0;
        background: $primary-background;
        z-index:9;
        text-align: start;
        padding:0px;
        border:none;
        }
    }
    tbody {
        width: 100%;
        overflow: auto;
        font-weight: 500;
        tr{
        height:40px;
        border-bottom: 1px solid $primary-background;
        padding:0px;
        }
    }
    }

.delete-btn {
  visibility: hidden;
}
.comm-table-row:hover .delete-btn {
  visibility: visible;
  position: relative;
  inset-inline-start:18px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.height-set-for-component {
  height: calc(100% - 120px);
}

::v-deep{
  .multiselect{
        width:100% !important;
        margin: 3px 0px;
  }
  .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag, .tags-style {
    background-color: $primary-background !important;
    border: $border-color;
    border-radius: 5px;
    margin-bottom:0px;
  }
  .multiselect__tags, .tags-style {
    background: $primary-background !important;
    border: $border-color !important;
  }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
    .multiselect__tag-icon{
       color:$text-color;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color !important;
       font-size: 20px;
    }

    // .multiselect__tag-icon{
    //   visibility:hidden;
    // }

    // .multiselect__tag:hover .multiselect__tag-icon{
    //   visibility:visible;
    // }

    .multiselect *{
        font-size: $input-field-and-label-font-size;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect__placeholder {
      padding-top: 0px;
      margin-bottom:0px;
     }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:28%;
      min-height: 38px;
    }
    .multiselect__single{
      padding-top:3px;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: absolute;
        display: block;
        background: $text-color;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background!important;
        height: auto;
        min-height: 45px;
    }
}

.browse-icon{
    position: relative;
    inset-inline-start:8px;
    top: 8px;
}

.table td, .table th {
    border-top: none;
    padding:0px;
}

.display-as-tags{
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: start;
    float: inline-start;
}

.select-catalog-field{
    width: 101%;
    .value-style{
      width:100%;
    }
}

.editIconClass{
  visibility: hidden;
}

.comm-screen-profile-fields:hover{
  .editIconClass{
    visibility: visible;
    margin-inline-start: 8px;
  }
}

.user-name-or-image-in-selected-option{
  border: $border-color;
  height: 27px;
  width: 27px;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  text-transform: uppercase;
  margin-top: -1px;
  margin-inline-start: -1px;
  }

.tags-style{
    display: inline-flex;
    margin-inline-end: 5px;
    margin-bottom: 5px;
    height: 27px;
    margin-inline-start: 3px;
    float:inline-start;
  .user-name-display-as-tags{
      line-height: 27px;
      margin: 0px 5px;
      width:auto;
  }
}
.add-screens-styles{
    display: inline-flex;
    height: 45px;
    border: 1px solid #4a4a4a;
    border-radius: 5px;
    width: 100%;
    margin-block: 8px;
    margin-inline-start: 0;
    margin-inline-end: 10px;
    color: #757575;
    font-size: 15px;
    align-items: center;
    justify-content: center;
    svg{
      margin-inline-end: 7px;
      color:$add-button-text-color !important;
    }
}

.add-screens-styles:hover{
    // border: 1px solid $add-button-text-color-hover;
    color:$add-button-text-color-hover;
    svg{
      color:$add-button-text-color-hover !important;
    }
}
</style>